export default "__VITE_ASSET__By6d6bG9__"